import React, { Component } from "react";
// import './HomeStyle.scss';
import "./HomeStyle.scss";
import * as Scroll from "react-scroll";
import history from "../../imports/history";

import Navbar from "../../layouts/public-navbar/NavBarDS";
import Footer from "../../layouts/public-footer/Footer";

import Header from "./components/Header";
import InternalNav from "./components/InternalNav";
import DescriptionSection from "./components/DescriptionSection";
import FeatureSection from "./components/FeatureSection";
import ProgramCourses from "./components/ProgramCourses";
import TeachersSection from "./components/TeachersSection";
import CertificateSection from "./components/CertificateSection";
import LinkToFaq from "./components/LinkToFaq";
import CompleteDescription from "./components/CompleteDescription";
import CompanyRegister from "./components/CompanyRegister";
import Banner from "./components/Banner";
import CourseStructure from "./components/CourseStructure";
import FinalLinks from "./components/FinalLinks";
import { ajaxJson } from "imports/ajax";

import * as qs from "imports/query-string";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import Glance from "./components/Glance";
import VideoSec from "./components/VideoSec";
import Modal from "react-modal";
import { sendBru_api } from "./HomeApi";


function englishNumber(string) {
    return string.split("۰").join("0")
        .split("۱").join("1")
        .split("۲").join("2")
        .split("۳").join("3")
        .split("۴").join("4")
        .split("۵").join("5")
        .split("۶").join("6")
        .split("۷").join("7")
        .split("۸").join("8")
        .split("۹").join("9");
}

const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)"
    }
};

export default class HomePage extends Component {
    constructor(props) {
        super(props);
        this.scrollRef = React.createRef();
        this.state = {
            phoneNumber: "",
            activeBtn: true,
            modalBruIsOpen: false,
            mobileNumber: "",
            sendStatus:"default",
            spin:false

        };
    }


    scrollToRef = () => {
        window.scrollTo({
            left: 0,
            top: this.scrollRef.current.offsetTop,
            behavior: "smooth"
        });
    };


    componentDidMount() {
        window.scrollTo(0, 0);
        document.getElementById("root").className = "home-page";
        this.props.initData();
        const queryParams = qs.parse(this.props.location.search);
        if (queryParams.go) {
            setTimeout(() => {
                Scroll.scroller.scrollTo("mba", {
                    duration: 0,
                    smooth: false,
                    offset: 50
                });
            }, 600);
        }
        if (!this.state.modalFirstShow) {
            this.setState({ modalIsOpen: true });
            this.setState({ modalFirstShow: true });
        }


    }

    componentWillUnmount() {
        document.getElementById("root").className = "";
    }

    createUserWithNumber = () => {
        if (this.state.phoneNumber) {
            this.setState({
                activeBtn: false
            });
            ajaxJson.post(`/users/consultation-user`, { phone: englishNumber(String(this.state.phoneNumber)) })
                .then(res => {
                        toast.success("درخواست شما با موفقیت ثبت شد");
                        this.setState({
                            activeBtn: true
                        });
                    },
                    err => {
                        this.setState({
                            activeBtn: true
                        });
                    }
                );
        }

    };


    openModal() {
        this.setState({ modalBruIsOpen: true });
    }

    closeModal() {
        this.setState({ modalBruIsOpen: false });
    }

    setMobileNumber(e) {
        this.setState({ mobileNumber: e.target.value });
    }

    async sendBru(e) {
        this.setState({ spin: true });
        if(this.state.mobileNumber.length > 5) {
            try{
                const res = await sendBru_api(this.state.mobileNumber);
                this.setState({ sendStatus: "success" });
            }catch (e) {
                this.setState({ sendStatus: "error" });
            }
        }
    }



    render() {
        return (
            <div id="home-page">
                <Helmet>
                    <title>آکادمی درایت - خانه</title>
                </Helmet>
                <Navbar isHome/>
                <Header
                    slides={this.props.headerSlides}
                    onClickSlide={slide =>
                        // this.props.buyProgram(slide.programId)
                        history.push("/mba-program/advantages")
                    }
                />
                <DescriptionSection scroll={this.scrollToRef}/>
                <div className="home-banner-section">
                    <img src="/images/mba-home-banner.jpg" alt=""/>
                </div>
                <div className="course-structure" ref={this.scrollRef}>
                    <div className="course-structure__content">
                        <h2 className="title">برای دریافت مشاوره شماره همراه خود را وارد نمایید</h2>
                        <div className="row">
                            <input onChange={
                                (e) => {
                                    this.setState({
                                        phoneNumber: e.target.value
                                    });
                                }
                            }
                                   value={this.state.phoneNumber}
                                   placeholder="شماره همراه" className="get-number-input"/>
                            {this.state.activeBtn ? (
                                <span className="submit-number-btn" onClick={() => this.createUserWithNumber()}>ثبت شماره</span>
                            ) : (
                                <span className="submit-number-btn-gray">در حال ثبت</span>
                            )
                            }
                        </div>
                    </div>
                </div>
                <FeatureSection/>
                <CourseStructure/>
                <Glance/>
                <TeachersSection teachers={this.props.featureTeachers}/>
                <VideoSec/>
                <CertificateSection/>
                {/*<CompanyRegister />*/}
                <FinalLinks/>
                <Footer/>
                <div className="float-register">
                    <div className="float-register-sec">
                        <div className="float-call" onClick={e=>{
                            document.location.href=`tel:02166089773`;
                        }}><span className="icon icon-dr-tell"></span><span
                            className="call-label">۶۶۰۸۹۷۷۳ - ۰۲۱</span></div>
                        <a href="/program/MSJxezbNT3">
                            <div className="float-register-btn"><span
                                className="icon icon-dr-user"></span><span>آشنایی با دوره و ثبت نام</span></div>
                        </a>
                        <div className="float-bru-btn" onClick={() => {
                            // this.openModal();
                            this.scrollToRef()
                        }}><span
                            className="icon icon-list"></span><span>دریافت مشاوره</span></div>
                    </div>
                </div>

                {/*<Modal*/}
                {/*    isOpen={this.state.modalBruIsOpen}*/}
                {/*    onRequestClose={e => this.closeModal()}*/}
                {/*    contentLabel="ضمیمه"*/}
                {/*    style={customStyles}*/}
                {/*    className=""*/}
                {/*>*/}

                {/*    <div className="float-register-modal">*/}
                {/*        <div className="float-register-modal-title"><span>برای دریافت بروشور لطفا شماره همراه خود را وارد نمایید</span>*/}
                {/*        </div>*/}
                {/*        <div className="bru-mobile-input"><span className="icon icon-mobile"></span>*/}
                {/*            <input type="text"*/}
                {/*                   name="" id=""*/}
                {/*                   placeholder="شماره موبایل"*/}
                {/*                   onChange={e=>this.setMobileNumber(e)}*/}
                {/*                   value={this.mobileNumber}*/}
                {/*                   />*/}
                {/*        </div>*/}
                {/*        {this.state.sendStatus==="error"?*/}
                {/*            <div className="float-modal-error-message">*/}
                {/*                <span>مشکل در ارسال , مجددا سعی نمایید</span>*/}
                {/*            </div>:null*/}
                {/*        }*/}

                {/*        {this.state.sendStatus==="success"?*/}
                {/*                <div className="float-modal-success-message">*/}
                {/*                    <span>بروشور با موفقیت برای شما ارسال شد</span>*/}
                {/*                </div>:null}*/}

                {/*        <div className="float-bru-modal-btn" onClick={e=>{*/}
                {/*            this.sendBru()*/}
                {/*        }}><span>ارسال بروشور</span></div>*/}
                {/*    </div>*/}
                {/*</Modal>*/}


            </div>
        );
    }
}
